import React from 'react';
import './courseQuizCard.css'

function C2wCourseQuizCard( { obj, svg } ) {
    return (
        <div className='C2wCourseQuizCard_ctn'>
            <div className='C2wCourseQuizCard_heading'><span>{obj?.spanTitle}</span>{' Quiz'}</div>
            <p>{obj?.desc}</p>
           {svg}

        </div>
    )
}

export default C2wCourseQuizCard
